import { ref, watch } from "vue";
import KeenSlider from "keen-slider";
import { type DsButtonRefType } from "@sazka/design-system/src/button/ds-button-reference";
import { useIntersectionObserver } from "@sazka/utils/composables/use-intersection-observer";
import { GamesAnalytics } from "@/games/analytics/analytics-games";
import useKeenAutoplayPlugin from "@/shared/keen-slider/plugins/keen-autoplay-plugin";
import useCustomNavigationPlugin from "@/shared/keen-slider/plugins/keen-custom-navigation-plugin";

document.ready(() => {
    const carouselElement = document.getElementById("games-carousel");
    const isEditMode = environment.isEditMode;

    if (!carouselElement) return;

    const prevButton = ref<DsButtonRefType>(document.querySelector<HTMLButtonElement>(".js-games-carousel-prev"));
    const dots = ref<HTMLElement>(document.querySelector(".js-games-carousel-dots"));
    const nextButton = ref<DsButtonRefType>(document.querySelector<HTMLButtonElement>(".js-games-carousel-next"));

    const autoplaySecondsSetting = carouselElement.dataset.autoplaySeconds;
    const autoplaySeconds = parseInt(autoplaySecondsSetting);
    const keensliderOptions = [useCustomNavigationPlugin(prevButton, nextButton, dots)];

    if (autoplaySeconds) {
        const { keenAutoplayPlugin, stopKeenAutoplay } = useKeenAutoplayPlugin(autoplaySeconds * 1000, false);
        const { isIntersecting } = useIntersectionObserver(carouselElement);
        watch(isIntersecting, (value) => {
            stopKeenAutoplay.value = !value;
        });

        keensliderOptions.push(keenAutoplayPlugin);
    }

    const initSlider = () => {
        new KeenSlider(
            carouselElement,
            {
                loop: true,
                defaultAnimation: {
                    duration: 1000,
                },
                selector: ".games-carousel__item",
                detailsChanged: (slider) => {
                    slider.slides.forEach((slide, index) => {
                        slide.style.visibility = `${index === slider.track.details.rel ? "visible" : "hidden"}`;
                    });
                },
                renderMode: isEditMode ? "precision" : "custom",
                slideChanged: () => GamesAnalytics.pushBannerChange(),
            },
            keensliderOptions
        );
    };

    initSlider();
    GamesAnalytics.initBannersAnalytics();
});
